import { Injectable } from '@angular/core';
import moment from 'moment-timezone';


@Injectable({
  providedIn: 'root'
})
export class DateTimeHelperService {

  getEstDate(): moment.Moment {
    return moment.utc().tz('America/New_York');
  }

  getEstDateTimeString(): string {
    return moment.utc().tz('America/New_York').format("MM-DD-YYYY hh:mm:ss A");
  }
  getEstDateString(): string {
    return moment.utc().tz('America/New_York').format("MM-DD-YYYY");
  }

  parseDateToMoment(date: Date){
    return moment(date);
  }

  parseDateToDateString(date: Date): string {
    return moment(date).format("MM-DD-YYYY");
  }

  parseDateToDateTimeString(date: Date): string {
    return moment(date).format("MM-DD-YYYY hh:mm:ss A");
  }

  parseDatetoUtc(date: Date): moment.Moment{
    return moment.utc(date);
  }

  parseUtcStringToEstDateString(date: string): string{
    return moment.utc(date).tz('America/New_York').format("MM-DD-YYYY");
  }

  parseUtcDateToEstDateString(date: Date): string{
    return this.parseUtcStringToEstDateString(date.toDateString());
  }

  parseUtcStringToEstDateTimeString(date: string): string{
    let dateValue = moment.utc(date).tz('America/New_York').format("MM-DD-YYYY hh:mm:ss A");
    return dateValue;
  }

  parseUtcDateToEstDateTimeString(date: Date): string{
    return this.parseUtcStringToEstDateTimeString(date.toDateString());
  }

  isPastSettlementDate(date: Date){
    let mTodaysDate = this.getEstDate();
    let mSelectedSettlementDate = this.parseDateToMoment(date);
    let result = mSelectedSettlementDate.isBefore(mTodaysDate, 'day');
    return result;
  }

  isFutureSettlementDate(date: Date){
    let mTodaysDate = this.getEstDate();
    let mSelectedSettlementDate = this.parseDateToMoment(date);
    let result = mSelectedSettlementDate.isAfter(mTodaysDate, 'day');
    return result;
  }

}
